import { useCallback, useState } from "react";
import { Defined, TriggeredHook } from "sonobello.utilities.react";

import { Customer } from "../../../../Models/Customer";
import { Error } from "../../../../Utils/Errors";
import OpsEndpointPathsUtility from "../../../../Utils/OpsEndpointPathsUtility";
import { useApi } from "../../../../Utils/useApi";

/** When executed, dispatches a prepared updated state to an existing customer to be persisted by the server. */
const useUpdatePreparedCustomer: TriggeredHook<
  boolean,
  undefined,
  boolean,
  { contactId: string; customer: Customer & Defined<Pick<Customer, "id">> }
> = ({ contactId, customer }) => {
  const [shouldDispatchRequest, setShouldDispatchRequest] = useState(false);

  const { response, isLoading, error } = useApi<Customer, Customer>({
    method: "put",
    url: shouldDispatchRequest ? OpsEndpointPathsUtility.aspirePutCustomerUrl(contactId, customer.id) : undefined,
    data: customer,
    valid: shouldDispatchRequest,
    error: Error.PutCustomer
  });

  const execute = useCallback(() => setShouldDispatchRequest(true), []);

  return {
    result: Boolean(response) || null,
    error: Boolean(error) || null,
    execute,
    isLoading
  };
};

export default useUpdatePreparedCustomer;
